import { render, staticRenderFns } from "./cyzxCov.vue?vue&type=template&id=58c58d63&scoped=true"
import script from "./cyzxCov.vue?vue&type=script&lang=js"
export * from "./cyzxCov.vue?vue&type=script&lang=js"
import style0 from "./cyzxCov.vue?vue&type=style&index=0&id=58c58d63&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c58d63",
  null
  
)

export default component.exports